import React from "react";
import {
  IconLayoutSidebarRightCollapse,
  IconPencil,
} from "@tabler/icons-react";
import clsx from "clsx";
import Tooltip from "components/Tooltip";
import { observer } from "mobx-react-lite";
import RenameRulePopup from "../features/RenameRulePopup";
import { rulesSetStore } from "../RulesSetStore";

interface OverviewHeader {
  title: string | undefined;
  close: () => void;
}

const OverviewHeader = (props: OverviewHeader) => {
  const [openRenamePopup, setOpenRenamePopup] = React.useState(false);

  return (
    <div
      className={clsx(
        "py-3 px-6 flex items-center justify-between sticky top-0 z-10 bg-white border-b"
      )}
    >
      <div className="flex items-center">
        <IconLayoutSidebarRightCollapse
          size={24}
          className="text-indigo-700 cursor-pointer mr-4 min-w-[23px]"
          onClick={props.close}
        />
        <Tooltip
          className="font-semibold text-lg !cursor-auto text-left max-w-[320px]"
          truncate
        >
          {props.title}
        </Tooltip>
        <IconPencil
          className="text-indigo-700 ml-2 cursor-pointer hover:text-indigo-800"
          onClick={() => setOpenRenamePopup(true)}
        />
      </div>
      <RenameRulePopup
        rule={rulesSetStore.currentRule}
        open={openRenamePopup}
        close={() => setOpenRenamePopup(false)}
      />
    </div>
  );
};

export default observer(OverviewHeader);
